// extracted by mini-css-extract-plugin
export default {"hawk-base-wrapper":"hawk-master-widget-hawk-base-wrapper"};